<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/waterCard/cardList')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 选择 -->
    <div class="flex mgt-30 mgb-50">
      <div
        :class="selectActive == v.id ? 'topselectActive' : 'topselect'"
        v-for="v in select"
        :key="v.id"
        @click="selectBtn(v)"
      >
        {{ v.name }}
      </div>
    </div>

    <!-- 导入 -->
    <div v-if="selectActive == 1">
      <div class="fw-600">批量导入充值</div>
      <div class="color409eff cursor mgt-30" @click="download">
        下载Excle示例
      </div>
      <div class="fw-600 mgt-30 mgb-30">导入Excel</div>
      <el-upload
        ref="upload"
        :action="'#'"
        :limit="1"
        :multiple="false"
        :auto-upload="false"
        accept=".xls,.xlsx"
        :file-list="fileList"
        :http-request="uploadFile"
        :on-change="fileChange"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
      >
        <el-button size="small" type="primary">文件浏览</el-button>
      </el-upload>
      <!-- biao -->
      <div class="mgt-10">
        <el-form
          :rules="tabelFormRules"
          ref="tabelForm"
          :model="tabelForm"
          label-width="80px"
        >
          <el-form-item label="充值方式">
            <el-radio-group
              v-model="tabelForm.tabelTopWay"
              @input="tabelTopWayInput"
            >
              <el-radio label="套餐充值"></el-radio>
              <!-- <el-radio label="自定义充值"></el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="充值套餐"
            v-if="tabelForm.tabelTopWay == '套餐充值'"
            prop="menu"
          >
            <el-select
              @change="tabelFormMenuChange"
              v-model="tabelForm.menu"
              placeholder="请选择充值套餐"
            >
              <el-option
                v-for="v in menuArr"
                :key="v.id"
                :label="
                  v.name +
                    '-' +
                    (v.cardType === 2 ? '实物卡套餐' : '电子卡套餐')
                "
                :value="v.id"
                @click.native="tableMenuSelect(v)"
              ></el-option>
            </el-select>
          </el-form-item>
          <div v-if="excelShow">
            <el-form-item label="支付金额" prop="payPrice">
              <el-input
                v-model="tabelForm.payPrice"
                placeholder="请输入支付金额"
                :disabled="excelDis"
                @input="payPriceInput"
              ></el-input>
            </el-form-item>
            <el-form-item label="赠送金额" prop="givePrice">
              <el-input
                v-model="tabelForm.givePrice"
                placeholder="请输入赠送金额"
                :disabled="excelDis"
                @input="givePriceInput"
              ></el-input>
            </el-form-item>
            <el-form-item label="实际到账">
              <el-input
                v-model="tabelForm.intoPrice"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-button type="primary" class="mgt-30" @click="tableTopBtn('tabelForm')"
        >提交订单</el-button
      >
    </div>

    <!-- 卡号充值 -->
    <div v-if="selectActive === 2">
      <el-form
        :rules="cardFormRules"
        ref="cardForm"
        :model="cardForm"
        label-width="80px"
      >
        <el-form-item label="开通方式">
          <el-radio-group v-model="cardForm.openWay" @input="openInput">
            <el-radio label="批量"></el-radio>
            <el-radio label="单个"></el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="cardForm.openWay == '批量'">
          <el-form-item label="起始卡号" prop="startCard">
            <el-input
              v-model="cardForm.startCard"
              placeholder="请输入起始卡号"
            ></el-input>
          </el-form-item>
          <el-form-item label="终止卡号" prop="endCard">
            <el-input
              v-model="cardForm.endCard"
              placeholder="请输入终止卡号"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item
          label="卡号"
          v-if="cardForm.openWay == '单个'"
          prop="card"
        >
          <el-input v-model="cardForm.card" placeholder="请输入卡号"></el-input>
        </el-form-item>
        <el-form-item label="充值方式">
          <el-radio-group v-model="cardForm.topWay" @input="topWayInput">
            <el-radio label="套餐充值"></el-radio>
            <!-- <el-radio label="自定义充值"></el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="充值套餐"
          v-if="cardForm.topWay == '套餐充值'"
          prop="menu"
        >
          <el-select
            v-model="cardForm.menu"
            placeholder="请选择充值套餐"
            @change="cardFormMenuChange"
          >
            <el-option
              v-for="v in menuArr"
              :key="v.id"
              :label="
                v.name + '-' + (v.cardType === 2 ? '实物卡套餐' : '电子卡套餐')
              "
              :value="v.id"
              @click.native="topMenuSelect(v)"
            ></el-option>
          </el-select>
        </el-form-item>

        <div v-if="cardTopShow">
          <el-form-item label="支付金额" prop="payPrice">
            <el-input
              v-model="cardForm.payPrice"
              placeholder="请输入支付金额"
              :disabled="cardDis"
              @input="payPriceInput2"
            ></el-input>
          </el-form-item>
          <el-form-item label="赠送金额" prop="givePrice">
            <el-input
              v-model="cardForm.givePrice"
              placeholder="请输入赠送金额"
              :disabled="cardDis"
              @input="givePriceInput2"
            ></el-input>
          </el-form-item>
          <el-form-item label="实际到账">
            <el-input v-model="cardForm.intoPrice" :disabled="true"></el-input>
          </el-form-item>
        </div>

        <!-- == -->
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="3"
            v-model="cardForm.dist"
            maxlength="100"
            show-word-limit
            placeholder="请输入充值备注"
          ></el-input>
        </el-form-item>
        <!-- === -->
        <!-- <el-form-item v-if="cardForm.openWay == '单个'" label="打款凭证">
          <el-upload
            class="avatar-uploader"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove2"
            :file-list="imgList"
            :http-request="uploadFile2"
            :limit="1"
            :maxCount="1"
            v-model="cardForm.img"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="img" alt="" />
          </el-dialog>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="cardTopBtn('cardForm')"
            >提交订单</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="flex aic mgb-10" v-if="tableShow">
      <div>
        <div class="mgb-30">可充值水卡数:{{ cardNum }}</div>
        <div class="mgb-30">充值金额:{{ payMoney }}</div>
        <el-button :disabled="disBtn" class="mgb-30" @click="topPay"
          >充值</el-button
        >
      </div>
      <img class="mgl-30" :src="codeImg" alt="" />
    </div>
    <div class="mgt-10 flex" v-if="tableShow">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="waterCard" label="卡号"> </el-table-column>
        <el-table-column prop="phone" label="手机号"> </el-table-column>
        <el-table-column prop="payPrice" label="支付金额"> </el-table-column>
        <el-table-column prop="givePrice" label="赠送金额"> </el-table-column>
        <el-table-column prop="orderPrice" label="实际到账"> </el-table-column>
        <el-table-column prop="afterBalance" label="充值后水卡金额">
        </el-table-column>
        <el-table-column prop="state" label="充值结果">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.state == 2
                  ? '未到账'
                  : scope.row.state == 3
                  ? '已到账'
                  : scope.row.state == 1
                  ? '待支付'
                  : '失败'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="说明"> </el-table-column>
      </el-table>
      <el-button @click="getTable()" type="primary" plain>刷新</el-button>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    // 新增联系人验证
    const price = (rule, value, callback) => {
      // var reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      var reg = /^\d+(?:\.\d{1,2})?$/;

      if (!value) {
        callback(new Error("请填写金额"));
      } else if (!reg.test(value)) {
        callback(new Error("只能输入正数，小数点后最多保留两位小数"));
      } else {
        callback();
      }
    };
    const givePrice = (rule, value, callback) => {
      var reg = /^[0-9]+([.][0-9]{1,2})?$/;
      //   var reg = /^(\.*)(\d+)(\.?)(\d{0,2}).*$/g;

      if (!value) {
        callback(new Error("请填写金额"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入数字，小数点后最多保留两位小数"));
      } else {
        callback();
      }
    };
    return {
      codeVisible: true,
      codeImg: "",
      fileList: [],
      select: [
        { id: 1, name: "批量导表充值" },
        { id: 2, name: "卡号充值" },
      ],
      cardNum: "",
      payMoney: "",
      selectActive: 1,
      tabelForm: {
        tabelTopWay: "套餐充值",
        menu: "",
        payPrice: "",
        givePrice: "",
        intoPrice: "",
      },
      excelShow: true,
      excelDis: true,
      tabelFormRules: {
        menu: [{ required: true, message: "请选择充值套餐", trigger: "blur" }],
        payPrice: [{ required: true, validator: price, trigger: "blur" }],
        givePrice: [{ required: true, validator: givePrice, trigger: "blur" }],
      },
      disBtn: false,
      cardForm: {
        openWay: "批量",
        startCard: "",
        endCard: "",
        card: "",
        topWay: "套餐充值",
        payPrice: "",
        givePrice: "",
        intoPrice: "",
        img: "",
        dist: "",
      },
      cardTopShow: true,
      cardDis: true,
      cardFormRules: {
        menu: [{ required: true, message: "请选择充值套餐", trigger: "blur" }],
        payPrice: [{ required: true, validator: price, trigger: "blur" }],
        givePrice: [{ required: true, validator: givePrice, trigger: "blur" }],
        startCard: [
          { required: true, message: "请输入起始卡号", trigger: "blur" },
        ],
        endCard: [
          { required: true, message: "请输入终止卡号", trigger: "blur" },
        ],
        card: [{ required: true, message: "请输入卡号", trigger: "blur" }],
        dist: [
          { required: true, message: "请输入充值备注", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        img: [{ required: true, message: "请上传打款凭证", trigger: "blur" }],
      },
      menuArr: [],
      tableData: [],
      tableShow: false,
      batch: null,
      imgList: [], //照片列表
      dialogVisible: false,
      img: "",
      distImg: "",
    };
  },

  created() {
    this.excelShow = false;
    this.cardTopShow = false;
    this.getMenu();
  },

  methods: {
    topPay() {
      this.$api.waterCard
        .codeImg({ batch: this.batch, payType: 3 })
        .then((res) => {
          if (res.code === 200) {
            this.codeImg = res.data.img;
            this.disBtn = true;
          }
        });
    },
    handlePictureCardPreview(file) {
      this.img = file.url;
      this.dialogVisible = true;
    },
    handleRemove2(file, fileList) {
      this.imgList = fileList;
      this.cardForm.img = "";
    },
    /* 自定义上传 */
    uploadFile2(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          // this.img = URL.createObjectURL(params.file);
          // this.changeHeadImgform.headUrl = res.data[0];
          this.img = res.data[0];
          this.cardForm.img = res.data[0];
          this.imgList.push({
            url: res.data[0],
          });
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    selectBtn(v) {
      this.selectActive = v.id;
      this.tableShow = false;
      this.getMenu();
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },

    getMenu() {
      this.$api.waterCard
        .menuArr({
          cardType: 2,
        })
        .then((res) => {
          if (res.code === 200) {
            console.log(res, "充值套餐");
            this.menuArr = res.data;
          }
        });
    },

    // 导表模板下载
    download() {
      this.$api.waterCard.topTemplate().then((res) => {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(res);
        link.setAttribute("download", "充值模板.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.waterCard
        .topUpload({
          file: formData,
          payMoney: this.tabelForm.payPrice,
          giveMoney: this.tabelForm.givePrice,
          packageId: this.tabelForm.menu,
          payType: 5,
          orderType: 2,
        })
        .then((res) => {
          if (res.code === 200) {
            //   this.addVisible = false;
            handleAlert("导入成功", "success");
            this.tabelForm = {
              tabelTopWay: "套餐充值",
              menu: "",
              payPrice: "",
              givePrice: "",
              intoPrice: "",
            };
            this.disBtn = false;
            this.cardNum = res.data.cardNum;
            this.payMoney = res.data.payMoney;
            this.excelShow = false;
            this.batch = res.data.data;
            this.getTable();
          }
        });
      /* ------------------------------------ */
      // 成功失败都删除文件;
      this.fileList.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      this.file = file;
      // console.log(fileList);
      this.fileList = fileList;
      console.log(this.fileList, "已上传的");
      console.log(file, fileList, "第一个");
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx和xls的文件");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
    },

    getTable() {
      this.$api.waterCard.topList({ batch: this.batch }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.tableShow = true;
        }
      });
    },

    tabelTopWayInput(n) {
      if (n == "自定义充值") {
        this.excelShow = true;
        this.tabelForm = {
          tabelTopWay: "自定义充值",
          menu: "",
          payPrice: "",
          givePrice: "",
          intoPrice: "",
        };
        this.excelDis = false;
      } else {
        this.excelShow = false;
        this.tabelForm = {
          tabelTopWay: "套餐充值",
          menu: "",
          payPrice: "",
          givePrice: "",
          intoPrice: "",
        };
        this.excelDis = true;
      }
    },

    topWayInput(n) {
      if (n == "自定义充值" && this.cardForm.openWay == "批量") {
        this.cardTopShow = true;
        // this.cardForm = {
        //   openWay: "批量",
        //   startCard: "",
        //   endCard: "",
        //   card: "",
        //   topWay: "自定义充值",
        //   menu: "",
        //   payPrice: "",
        //   givePrice: "",
        //   intoPrice: "",
        //   disc: "",
        // };
        this.cardForm.openWay = "批量";
        this.cardForm.topWay = "自定义充值";
        this.cardForm.menu = "";
        this.cardForm.payPrice = "";
        this.cardForm.givePrice = "";
        this.cardForm.intoPrice = "";
        this.cardForm.dist = "";
        this.cardForm.img = "";
        this.cardDis = false;
      } else if (n == "套餐充值" && this.cardForm.openWay == "批量") {
        this.cardTopShow = false;
        // this.cardForm = {
        //   openWay: "批量",
        //   startCard: "",
        //   endCard: "",
        //   card: "",
        //   topWay: "套餐充值",
        //   menu: "",
        //   payPrice: "",
        //   givePrice: "",
        //   intoPrice: "",
        //   dist: "",
        // };
        this.cardForm.openWay = "批量";
        this.cardForm.topWay = "套餐充值";
        this.cardForm.menu = "";
        this.cardForm.payPrice = "";
        this.cardForm.givePrice = "";
        this.cardForm.intoPrice = "";
        this.cardForm.dist = "";
        this.cardForm.img = "";
        this.cardDis = true;
      } else if (n == "自定义充值" && this.cardForm.openWay == "单个") {
        this.cardTopShow = true;
        // this.cardForm = {
        //   openWay: "单个",
        //   startCard: "",
        //   endCard: "",
        //   card: "",
        //   topWay: "自定义充值",
        //   menu: "",
        //   payPrice: "",
        //   givePrice: "",
        //   intoPrice: "",
        //   dist: "",
        //   img: "",
        // };
        this.cardForm.openWay = "单个";
        // this.cardForm.startCard = "";
        // this.cardForm.endCard = "";
        this.cardForm.topWay = "自定义充值";
        this.cardForm.menu = "";
        this.cardForm.payPrice = "";
        this.cardForm.givePrice = "";
        this.cardForm.intoPrice = "";
        this.cardForm.dist = "";
        this.cardForm.img = "";

        this.imgList = [];
        this.cardDis = false;
      } else {
        this.cardTopShow = false;
        // this.cardForm = {
        //   openWay: "单个",
        //   startCard: "",
        //   endCard: "",
        //   card: "",
        //   topWay: "套餐充值",
        //   menu: "",
        //   payPrice: "",
        //   givePrice: "",
        //   intoPrice: "",
        //   dist: "",
        //   img: "",
        // };
        this.cardForm.openWay = "单个";
        // this.cardForm.startCard = "";
        // this.cardForm.endCard = "";
        this.cardForm.topWay = "套餐充值";
        this.cardForm.menu = "";
        this.cardForm.payPrice = "";
        this.cardForm.givePrice = "";
        this.cardForm.intoPrice = "";
        this.cardForm.dist = "";
        this.cardForm.img = "";
        this.imgList = [];

        this.cardDis = true;
      }
    },

    tableMenuSelect(v) {
      this.tabelForm.payPrice = v.payPrice;
      this.tabelForm.givePrice = v.givePrice;
      this.tabelForm.intoPrice = v.orderPrice;
    },

    topMenuSelect(v) {
      this.cardForm.payPrice = v.payPrice;
      this.cardForm.givePrice = v.givePrice;
      this.cardForm.intoPrice = v.orderPrice;
    },

    // 导表充值方式选择
    tabelFormMenuChange(n) {
      if (this.tabelForm.tabelTopWay == "套餐充值" && n) {
        this.excelShow = true;
      }
    },

    // 卡号充值方式选择
    cardFormMenuChange(n) {
      if (this.cardForm.topWay == "套餐充值" && n) {
        this.cardTopShow = true;
      }
    },

    // 导表自定义实际到账金额计算
    payPriceInput() {
      if (this.tabelForm.givePrice) {
        this.tabelForm.intoPrice =
          Number(this.tabelForm.payPrice) + Number(this.tabelForm.givePrice);
      } else {
        this.tabelForm.intoPrice = this.tabelForm.payPrice;
      }
    },
    givePriceInput() {
      if (this.tabelForm.payPrice) {
        this.tabelForm.intoPrice =
          Number(this.tabelForm.payPrice) + Number(this.tabelForm.givePrice);
      } else {
        this.tabelForm.intoPrice = this.tabelForm.givePrice;
      }
    },
    payPriceInput2() {
      if (this.cardForm.givePrice) {
        this.cardForm.intoPrice =
          Number(this.cardForm.payPrice) + Number(this.cardForm.givePrice);
      } else {
        this.cardForm.intoPrice = this.cardForm.payPrice;
      }
    },
    givePriceInput2() {
      if (this.cardForm.payPrice) {
        this.cardForm.intoPrice =
          Number(this.cardForm.payPrice) + Number(this.cardForm.givePrice);
      } else {
        this.cardForm.intoPrice = this.cardForm.givePrice;
      }
    },

    tableTopBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        } else {
          return false;
        }
      });
    },

    cardTopBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.cardForm.openWay == "批量") {
            this.$api.waterCard
              .cardTopBatch({
                cardEnd: this.cardForm.endCard,
                cardStart: this.cardForm.startCard,
                giveMoney: this.cardForm.givePrice,
                packageId: this.cardForm.menu ? this.cardForm.menu : null,
                payMoney: this.cardForm.payPrice,
                remark: this.cardForm.dist,
                payType: 5,
                remarkImg: "",
                orderType: 2,
              })
              .then((res) => {
                if (res.code === 200) {
                  this.cardForm = {
                    openWay: "批量",
                    startCard: "",
                    endCard: "",
                    card: "",
                    topWay: "套餐充值",
                    menu: "",
                    payPrice: "",
                    givePrice: "",
                    intoPrice: "",
                    dist: "",
                  };
                  this.payMoney = res.data.payMoney;
                  this.cardNum = res.data.cardNum;
                  this.disBtn = false;
                  this.batch = res.data.batch;
                  this.getTable();
                }
              });
          } else {
            if (this.imgList.length > 0) {
              this.imgList.forEach((v) => {
                this.distImg = v.url;
              });
            }
            this.$api.waterCard
              .cardTopOne({
                cardNo: this.cardForm.card,
                packageId: this.cardForm.menu ? this.cardForm.menu : null,
                giveMoney: this.cardForm.givePrice,
                payMoney: this.cardForm.payPrice,
                remark: this.cardForm.dist,
                remarkImg: this.distImg ? this.distImg : null,
                payType: 5,
                orderType: 2,
              })
              .then((res) => {
                if (res.code === 200) {
                  this.cardForm = {
                    openWay: "单个",
                    startCard: "",
                    endCard: "",
                    card: "",
                    topWay: "套餐充值",
                    menu: "",
                    payPrice: "",
                    givePrice: "",
                    intoPrice: "",
                    dist: "",
                    img: "",
                  };
                  this.disBtn = false;

                  this.imgList = [];
                  this.payMoney = res.data.payMoney;
                  this.cardNum = res.data.cardNum;
                  this.batch = res.data.batch;
                  this.getTable();
                  this.cardTopShow = false;
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    openInput(e) {
      this.getMenu();
      if (e === "批量" && this.cardForm.topWay == "套餐充值") {
        this.cardTopShow = false;
      } else {
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.topselect {
  width: 500px;
  height: 30px;
  background: var(--card-bg);
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.topselectActive {
  width: 500px;
  height: 30px;
  background: var(--accent);
  color: #fff;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.el-input,
.el-select,
.el-textarea {
  width: 300px !important;
}
</style>
